export enum AuroraControlMode {
  STACK = 'stack',
  UNIT = 'unit'
}

export default AuroraControlMode
